import { FC, ReactElement, useEffect } from 'react'
import { useNavigate } from 'react-router'

import { BaseScheduleFormData } from '../../../../@paco/entities/BaseSchedule/BaseSchedule'
import checkPermission from '../../../../@paco/helpers/permissions/checkPermission'
import { createBaseSchedule } from '../../../../@paco/redux/baseSchedule/baseScheduleActions'
import { setIsSuccessful } from '../../../../@paco/redux/baseSchedule/baseScheduleReducer'
import { useTypedDispatch, useTypedSelector } from '../../../../@paco/redux/store'
import { ScheduleRoutes } from '../../../../@paco/routes/helpers'
import { PrivateRouteGroupRoutes } from '../../../../@paco/routes/routes'

import BaseSchedulesSidebar from '../../containers/BaseSchedules/BaseSchedulesSidebar/BaseSchedulesSidebar'

const ConnectedBaseSchedulesSidebar: FC = (): ReactElement => {
    const navigate = useNavigate()
    const typedDispatch = useTypedDispatch()

    const { isSuccessful, baseSchedule } = useTypedSelector(state => state.pacoBaseScheduleReducer)
    const { permissions } = useTypedSelector(state => state.authenticatedUserReducer)

    const canAddBaseSchedules = checkPermission(permissions, 'add-new-base-schedules')

    const handleAddBaseSchedule = (formData: BaseScheduleFormData) => {
        typedDispatch(createBaseSchedule(formData))
    }

    useEffect((): void => {
        if (isSuccessful && baseSchedule) {
            typedDispatch(setIsSuccessful(false))
            navigate(`${PrivateRouteGroupRoutes.shifts()}/${ScheduleRoutes.baseSchedule(baseSchedule.id)}`)
        }
    }, [isSuccessful])

    return (
        <BaseSchedulesSidebar
            canAddBaseSchedules={canAddBaseSchedules}
            onBaseScheduleSubmit={handleAddBaseSchedule}
        />
    )
}

export default ConnectedBaseSchedulesSidebar
